<ng-container>

  <div>
    <b>{{ name }}</b>
    <app-info class="formGroupLabel" [wide]="false" [placement]="'left'">
      <div class="tooltipContent">
        <b>Considering</b>
        <ul>
          @for (consider of splitConsidering(); track consider) {
            <div>
              <li>
                {{ consider }}
              </li>
            </div>
          }
        </ul>
      </div>
    </app-info>
  </div>

  <ng-container>
    <div class="row">
      <div class="col-md fieldset">
        <app-visit-exemptions-exemption-common [exemption]="exemption"></app-visit-exemptions-exemption-common>
      </div>
      <div class="col-md fieldset">
        <div class="row">
          <app-form-group label="Vessel type">
            <app-select [(ngModel)]="exemption.vesselType" (ngModelChange)="resetVesselInfo()" id="vesselType"
                        [options]="vesselTypes"
                        [formatter]="vesselTypesFormatter" required>
            </app-select>
          </app-form-group>
          @if (exemption.vesselType === 'IMO') {
            <app-form-group>
              <app-info class="formGroupLabel">
                <label>Vessel name/IMO number</label>
                <div class="tooltipContent">Name of vessel receiving cargo being pumped over</div>
              </app-info>
              <app-search [(ngModel)]="vessel" (ngModelChange)="onVesselChange(vessel)" [searchFunction]="searchVessel"
                          [inputFormatter]="vesselNameFormatter"
                          [minCharacters]="3" dataKey="imoCode" id="vessel">
              </app-search>
            </app-form-group>
          }
        </div>
        <div class="row">
          @if (exemption.vesselType === 'IMO') {
            <app-form-group label="Vessel name">
              <input [(ngModel)]="exemption.vesselNameIMO" id="vesselName" type="text" maxlength="64"
                     class="form-control" readonly required>
            </app-form-group>
          }
          @if (exemption.vesselType === 'IMO') {
            <app-form-group label="Vessel IMO">
              <input [(ngModel)]="exemption.vesselIMO" id="vesselIMO" type="text" maxlength="64"
                     class="form-control" readonly required>
            </app-form-group>
          }
          @if (exemption.vesselType === 'ENI') {
            <app-form-group label="Vessel name">
              <input [(ngModel)]="exemption.vesselNameENI" id="vesselNameENI" type="text" maxlength="64"
                     class="form-control" required>
            </app-form-group>
          }
          @if (exemption.vesselType === 'ENI') {
            <app-form-group label="Vessel ENI">
              <input [(ngModel)]="exemption.vesselENI" id="vesselENI" type="text" maxlength="64"
                     class="form-control" required>
            </app-form-group>
          }
        </div>
        <div class="row">
          <app-form-group label="Reason types">
            <app-multiselect id="relationTypes" [(ngModel)]="exemption.relationTypes" [options]="relationTypes"
                             [hideSelected]="true" required>
            </app-multiselect>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group label="Substance">
            <app-search [(ngModel)]="dangerousGoods" dataKey="name"
                        (ngModelChange)="onDangerousGoodsChange(dangerousGoods)"
                        [inputFormatter]="portVisitUtils.dangerousGoodsFormatter"
                        [searchFunction]="portVisitUtils.findDangerousGoods"
                        [resultFormatter]="portVisitUtils.dangerousGoodsFormatter"
                        placeholder="Find by name or UN code">
            </app-search>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group label="Substance name">
            <textarea [(ngModel)]="exemption.substanceName" id="substanceName" type="text" rows="3" maxlength="1024"
                      class="form-control" required></textarea>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group>
            <app-info class="formGroupLabel">
              <label>UN number</label>
              <div class="tooltipContent">If unknown select 0000</div>
            </app-info>
            <input [(ngModel)]="exemption.unVnNumber" id="unVnNumber" type="text" maxlength="256"
                   class="form-control" required>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group label="Reason for request for exemption">
            <app-info class="formGroupLabel">
              <label>Reason for request for exemption</label>
              <div class="tooltipContent">A minimum of 20 characters is required</div>
            </app-info>
            <textarea [(ngModel)]="exemption.reason" id="reason" type="text" rows="3" minlength="20" maxlength="1024"
                      class="form-control" required></textarea>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group label="Details">
            <textarea [(ngModel)]="exemption.details" id="details" type="text" rows="3" maxlength="256"
                      class="form-control"></textarea>
          </app-form-group>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>
